import { groupOfColor, colorsOfGroup } from "./colors.js";

const data = {
  "50": {
    "20x30": { white: 6, color: 7 },
    "30x40": { white: 7, color: 8 },
    "40x50": { white: 10, color: 12 },
    "50x60": { white: 17, color: 18 },
    "60x50": { white: 14, color: 16 },
  },
  "70": {
    "30x40": { white: 7, color: 8, gold: 15.4 },
    "40x50": { white: 12, color: 14, gold: 17.6 },
    "50x60": { white: 17, color: 19 },
    "60x50": { white: 16, color: 18 },
  },
  "80": {
    "20x30": { white: 6, color: 7 },
    "30x40": { white: 9, color: 11 },
    "40x50": { white: 13, color: 15 },
  },
};

export function packPrice(density, size, color) {
  const group = groupOfColor(color);
  return data?.[density]?.[size]?.[group];
}

export function densityScale() {
  return Object.keys(data);
}

export function sizeScale(density) {
  return Object.keys(data[density] ?? {});
}

export function defaultSize(density) {
  return sizeScale(density)[0];
}

export function colorsScale(density, size) {
  const groups = Object.keys(data?.[density]?.[size] ?? {});
  return groups.map((g) => colorsOfGroup(g)).flat();
}

export function defaultColor(density, size, prevColorName) {
  const scale = colorsScale(density, size);
  return scale.find((c) => c.name === prevColorName) || scale[0];
}
